module.exports = __webpack_public_path__ + "static/media/header.a033a5f7.png";